const initialState = {
    animal: {
        animals: [],
        culled: [],
        bulls: [],
        inseminations: [],
        milkResults: [],
        cattleLoading: false,
        bullLoading: false,
        culledLoading: false,
        sicknessList: [],
        tableOrder: {
            columns: [],
            orders: []
        },
        filterTypes: ['cow', 'heifer', 'calf', 'bull'],
        filterCowTypes: ['cow', 'heifer'],
        filtreBullTypes: ['calf', 'bull'],
        filterStates: [
            'nothing',
            'calved',
            'monitor',
            'inseminate',
            'ultrasound',
            'inseminated',
            'non-inseminated',
            'to-dry-up',
            'dried'
        ],
        filterCulled: [],
        filterBull: [],
    },
    farm: {
        farms: {},
        allBuildings: [],
        logs: [],
        filterActions: ['create', 'update', 'delete'],
        selectedFarm: null
    },
    profile: {
        profile: {
            id: '',
            firstname: '',
            lastname: '',
            roles: [],
        },
        users: [],
        token: '',
        loggedAt: null,
        passwordUpdated: false,
        md: null,
        online: true,
        loadingUser: false
    }
}

export default initialState